import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import { ContractStepModel } from '../../../../models/contract.model';
import { STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { TFormState } from '../../../../models/forms.model';
import { DocViewComponent } from '../../../../components/doc-view/doc-view.component';
import { MatDialog } from '@angular/material/dialog';
import { AppContractStepTargetSelectComponent } from '../contract-step-target-select/contract-step-target-select.component';
import { ContractContextMenuService } from '../../services/contract-context-menu.service';
import { IContractDataModel } from '../../models/contract-internal-models';
import { ContractDataService } from '../../services/contract-data.service';
import { Subscription } from 'rxjs';
import { ContractAvatarsService } from '../../services/contract-avatar.service';
import { ContractFormService } from '../../services/contract-form.service';


@Component({
    selector: 'app-contract-step-document',
    templateUrl: './contract-step-document.component.html',
    styleUrl: './contract-step-document.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractStepDocumentComponent {
    private subs:Subscription = new Subscription()
    @Input() public contractStep: ContractStepModel|null = null;
    @Input() public contractData: IContractDataModel|null = null;
    public formState:TFormState = 'Default'
    public stepsStylingMap = STEPS_STYLING_MAP
    public notSingedMembers:string[]|undefined = []
    public singedMembers:string[]|undefined = []
    constructor(
      private cds:ChangeDetectorRef,
      private contractDataService:ContractDataService,
      private contractFormService:ContractFormService,
      private dialog:MatDialog,
      private contextMenuService:ContractContextMenuService,
      public contractAvatarsService:ContractAvatarsService
    ) { }
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnInit(): void {
      this.subs.add(this.contractDataService.subStepDataChanged.asObservable().subscribe(()=>{
        this.prepareAvatars();
        this.cds.detectChanges();
      }))
    }
    ngOnChanges(): void {
      this.prepareAvatars()
    }
    prepareAvatars() {
      this.notSingedMembers = this.contractStep?.membersAvatarsToShow?.filter(el=>el.state===false).map(el=>el.guid)
      this.singedMembers = this.contractStep?.membersAvatarsToShow?.filter(el=>el.state===true).map(el=>el.guid)
    }
    viewDocumentInDialog() {
      if (this.contractStep?.target_key) {
        this.contractFormService.checkInterDomainRedirect(this.contractData.contract.contract).subscribe(()=>{
          let docViewComponentDialogRef = this.dialog.open(DocViewComponent, {
              minWidth: '90vw',
              minHeight: '96vh',
              panelClass: 'add-document-contract-step-padding-modalbox'
          })
          docViewComponentDialogRef.componentInstance.fileUkey = this.contractStep?.target_key
          docViewComponentDialogRef.componentInstance.zoomExt = '100'
        })
      }
    }
    addDocument() {
      this.contractFormService.checkInterDomainRedirect(this.contractData.contract.contract).subscribe(()=>{
        let stepSelectModal = this.dialog.open(AppContractStepTargetSelectComponent,{
                minWidth: '80vw',
              maxHeight: '95vh',
              panelClass: 'add-document-contract-step-padding-modalbox'
        })
        stepSelectModal.componentInstance.roadmap = this.contractData?.contract?.roadmap_active.steps!
        stepSelectModal.componentInstance.step = this.contractStep! 
        stepSelectModal.componentInstance.dialogToClose = stepSelectModal;
      })
    }
    deleteStep() {
      this.contextMenuService.subDeleteContextMenu.next({targetContext:'roadMapStep',event:null,data:this.contractStep,contractGuid:this.contractData.contract.contract.guid})
    }
}